import React from "react";
import "./Our_Services.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { icon } from "@fortawesome/fontawesome-svg-core";

const servicesData = [
  {
    title: "Service & Maintenance",
    link: "/services/maintenance",
    description:
      "Our Service & Maintenance programs are designed to keep your systems running efficiently, safely, and reliably. From routine inspections to emergency repairs, our team ensures optimal performance and minimal downtime. ",
    icon: "/assets/images/home/our_services/icon-service.png",
    image: "/assets/images/home/our_services/service.png",
  },
  {
    title: "Towing Services",
    link: "/services/towing",
    description:
      "Our Towing Services provide fast, reliable, and safe assistance whenever you face a vehicle breakdown or roadside emergency. Our team of trained professionals is equipped with modern towing equipment, allowing us to respond quickly.",
    icon: "/assets/images/home/our_services/icon-towing.png",
    image: "/assets/images/home/our_services/towing.png",
  },
  {
    title: "Body Repair (Dent & Paint)",
    link: "/services/body-repair",
    description:
      "At our Body Repair & Painting facility, we specialize in restoring vehicles to their original condition — combining advanced technology, skilled craftsmanship, and premium materials to deliver exceptional results. ",
    icon: "/assets/images/home/our_services/icon-repair.png",
    image: "/assets/images/home/our_services/repair.png",
  },
  {
    title: "Car Wash & Detailing",
    link: "/services/car-wash",
    description:
      "Keep your vehicle looking its best with our professional Car Wash & Detailing services. We specialize in thorough cleaning and restoration, both inside and out, to maintain your car’s appearance, hygiene, and value. Using high-quality cleaning products, advanced tools, and careful techniques, we remove dirt, grime, and stubborn stains while protecting your car’s paint.",
    icon: "/assets/images/home/our_services/icon-carwash.png",
    image: "/assets/images/home/our_services/carwash.png",
  },
  {
    title: "Vehicle Inspection & Valuation",
    link: "/services/inspection",
    description:
      "Our Vehicle Inspection & Valuation service ensures that you know the true condition and worth of your vehicle before any transaction or maintenance decision. We conduct a thorough inspection, examining every critical component, from the engine and transmission to the bodywork. ",
    icon: "/assets/images/home/our_services/icon-inspection.png",
    image: "/assets/images/home/our_services/inspection.png",
  },
  {
    title: "Outstation Rides",
    link: "/services/outstation-rides",
    description:
      "Traveling long distances has never been easier and more comfortable with our Outstation Ride services. Whether it’s a business trip, a family vacation, or a weekend getaway, we provide safe, reliable, and convenient transportation tailored to your needs.",
    icon: "/assets/images/home/our_services/icon-ride.png",
    image: "/assets/images/home/our_services/rides.png",
  },
  // {
  //   title:"Pickup service",
  //   link:"/services/pickup",
  //   description:"Experience the ultimate convenience with our Pickup & Drop-off Service. We make it easy for you to have your items collected and delivered without ever leaving your home or office.",
  //   icon:"",
  //   image:"/assets/images/services/pickup.png",

  // }
];

const Our_Services = () => {
  return (
    <section className="our_services">
      <div className="container">
        <Common_Title pageTitle=" We Provide" boxText="Our Services" />

        <div className="services">
          {servicesData.map((service, index) => (
            <div className="service_card" key={index}>
              <img
                src={service.image}
                alt={service.title}
                className="top_image"
              />
              <div className="card_content">
                <div className="icon_box">
                  <img src={service.icon} alt="icon" className="icon_img" />
                </div>
                <div className="text_div">
                  <h3 className="service_title">{service.title}</h3>
                  <p className="service_desc">{service.description}</p>
                  <Link to={service.link} className="read_more">
                    Read More{" "}
                    <FontAwesomeIcon
                      icon={faArrowRightLong}
                      className="angle_icon"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Our_Services;
